export const defaultStyles = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  flexWrap: "wrap",
  gap: "16px",
  backgroundColor: "var(--theme-website-color-background-primary)",
  borderWidth: "0",
  borderColor: "var(--theme-website-color-border-primary)",
  borderRadius: {
    border_left_top_radius: "0",
    border_left_bottom_radius: "0",
    border_right_top_radius: "0",
    border_right_bottom_radius: "0",
  },
  borderStyle: "solid",
  sizing: {
    width: "100%",
    height: "auto",
    minWidth: "auto",
    minHeight: "96px",
    maxWidth: "none",
    maxHeight: "none",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "20",
    paddingBottom: "20",
    paddingLeft: "20",
    paddingRight: "20",
  },
} as const;
